import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { delay, map } from 'rxjs/operators';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from '../services/shared-service.service';
import { catchError } from 'rxjs/operators';
import { of, TimeoutError } from 'rxjs';
import { timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})

export class MealPlanServiceV2 {

  private apiBaseUrl: string;
  chatApi = environment.chatapi + '/mealplan';
  newMealPlanApi = environment.chatapi + '/mealplan_v2';
  chatApiChat = environment.chatapi + '/mealplan/copilot/chat';
  chatApiDownload = environment.chatapi + '/mealplan/pdf/v1/';
  chatApiUpdate = environment.chatapi + '/mealplan/meal';
  chatApiRecipeUpdate = environment.chatapi + '/mealplan/meal/recipe';

  constructor(private http: HttpClient, private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
  }
  createMealPlan(mealDetails: any, isNewPlan: boolean) {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    return this.http.post(isNewPlan ? this.newMealPlanApi : this.chatApi, mealDetails, { headers }).pipe(timeout(600000),
      map((response) => response),
      catchError((error) => {
        console.log('error', error);
        if (error instanceof TimeoutError) {
          console.log('Request timed out');
          return of(1);
        }
        else {
          console.log('An error occurred:', error);
          return of(2);
        }
      }),
    );
  }

  getAllMeals(memberId: any, date: string, type: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.memberMealPlan + '/v2?memberId=' + memberId + '&date=' + date + '&type=' + type;
    return this.http.get(url, { headers });
  }

  getMealPlanDetails(id: any, fromDate: any, toDate: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/v2?planId=' + id + '&fromDate=' + fromDate + '&toDate=' + toDate;;
    return this.http.get(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("get meal plan details error", error);
        return of(1);
      }),
    );

  }

  /**
   * Get reusable meal plan templates.
   * Route: GET /api/mealplan/v2/templates
   */
  getMealPlanTemplates() {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/v2/templates';
    return this.http.get(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('get meal plan templates error', error);
        return of({ templates: [] });
      })
    );
  }

  /**
   * Get template by id for view page.
   * Route: GET /api/mealplan/v2/template-by-id?templateId=xxx
   */
  getTemplateById(templateId: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/v2/template-by-id?templateId=' + encodeURIComponent(templateId);
    return this.http.get(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('get template by id error', error);
        return of(null);
      })
    );
  }

  updateMealType(obj: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplanType/v2';
    return this.http.put(url, obj, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log("update meal type error", error);
        return of(1);
      }
      ),
    );
  }

  sendMessage(mealDetails: any) {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    return this.http.post(this.chatApiChat, mealDetails, { headers }).pipe(timeout(600000),
      map((response) => response),
      catchError((error) => {
        console.log('chat error', error);
        return of(1);
      }),
    );
  }

  addFasting(payload: any) {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    return this.http.put(this.chatApiUpdate, payload, { headers }).pipe(timeout(600000),
      map((response) => response),
      catchError((error) => {
        console.log('update chat api error', error);
        return of(1);
      }),
    );
  }

  updateRecipe(payload: any) {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    return this.http.put(this.chatApiRecipeUpdate, payload, { headers }).pipe(timeout(600000),
      map((response) => response),
      catchError((error) => {
        console.log('update chat api recipe error', error);
        return of(1);
      }),
    );
  }

  deleteMealPlan(id: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.memberMealPlan + '/v2?mealPlanId=' + id;
    return this.http.delete(url, { headers });
  }

  updateMemberMealPlan(payload: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.memberMealPlan + '/v2';
    return this.http.put(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      }));
  }

  // Update draft meal plan date range (fromDate / toDate).
  // Backend will accept either/both dates; we send only fields that changed, as strings.
  updateDraftMealPlanDates(payload: {
    id: string;
    memberId: string;
    fromDate?: string;
    toDate?: string;
    mealPlanName?: string;
  }) {
    const headers = this.sharedService.createAuthorizationHeader();
    // Matches FastEndpoints route: api/v2/memberMealPlan/dates
    const url = this.apiBaseUrl + 'memberMealPlan/dates';
    return this.http.put(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      })
    );
  }

  // Toggle a draft meal plan's visibility (isHide) on the member's mobile app.
  updateMealPlanHideStatus(payload: {
    id: string;
    memberId: string;
    mealPlanId: string;
    isHide: boolean;
  }) {
    const headers = this.sharedService.createAuthorizationHeader();
    // Matches FastEndpoints route: api/v2/memberMealPlan/hide
    const url = this.apiBaseUrl + 'memberMealPlan/hide';
    return this.http.put(url, payload, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      })
    );
  }

  downloadMealPlan(id: string) {
    const headers = this.sharedService.createAuthorizatioChatAPInHeader();
    const url = this.chatApiDownload + id;
    return this.http.get(url, { headers, responseType: 'blob' }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      }));
  }

  deleteRecipeFromMealPlan(mealId: any, recipeId: any, planId: any, day: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + `mealplan/v2/recipe?mealId=${mealId}&recipeId=${recipeId}&planId=${planId}&day=${day}`;
    return this.http.delete(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      }));
  }

  // Delete an entire meal (and its recipes) from a meal plan.
  // Backend expects planId, mealId and one or more recipeIds in the payload.
  deleteMealFromPlan(planId: any, mealId: any, recipeIds: any[], day: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealPlan/v2/meal';
    const body = {
      planId,
      mealId,
      recipeIds,
      day
    };
    // Use generic request() so we can send a body with DELETE
    return this.http.request('delete', url, { headers, body }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      })
    );
  }

  /**
   * Save an existing meal plan as a reusable template.
   * Backend expects the meal plan id and logged-in user id in the URL as query parameters.
   */
  saveMealPlanAsTemplate(planId: any, userId: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/v2/template?planId=' + planId + '&userId=' + userId;
    return this.http.post(url, null, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log(error);
        return of(1);
      })
    );
  }

  /**
   * Get the plan-input questions/answers captured when an app-generated meal plan was created.
   * Route: GET mealplan/questionanswers?planId=xxx
   */
  getPlanQuestionAnswers(planId: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + 'mealplan/questionanswers?planId=' + planId;
    return this.http.get(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('get plan question answers error', error);
        return of(1);
      })
    );
  }

  /**
   * Get members assigned to the logged-in user.
   * Route: GET api/members/assigned?userLoggedIn={id}
   */
  getAssignedMembers(userLoggedIn: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.members + '/assigned?userLoggedIn=' + encodeURIComponent(userLoggedIn);
    return this.http.get<{ members: any[] }>(url, { headers }).pipe(
      map((response) => response?.members ?? []),
      catchError((error) => {
        console.log('get assigned members error', error);
        return of([]);
      })
    );
  }

  /**
   * Delete a meal plan template.
   * Route: DELETE mealplan/v2/template?TemplateId=xxx
   */
  deleteTemplate(templateId: string) {
    const headers = this.sharedService.createAuthorizationHeader();
    const params = 'TemplateId=' + encodeURIComponent(templateId);
    const url = this.apiBaseUrl + 'mealplan/v2/template?' + params;
    return this.http.delete<{ message?: string }>(url, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('delete template error', error);
        throw error;
      })
    );
  }

  /**
   * Import a meal plan template to selected members.
   * Route: POST mealplan/v2/import-template
   * Query: templateId, userLoggedIn
   * Body: { "memberIds": ["id1", "id2", ...] }
   */
  importTemplateToMembers(templateId: string, userLoggedIn: string, memberIds: string[]) {
    const headers = this.sharedService.createAuthorizationHeader();
    const params = 'templateId=' + encodeURIComponent(templateId) + '&userLoggedIn=' + encodeURIComponent(userLoggedIn);
    const url = this.apiBaseUrl + 'mealplan/v2/import-template?' + params;
    return this.http.post<{ memberIds?: string[] }>(url, { memberIds }, { headers }).pipe(
      map((response) => response),
      catchError((error) => {
        console.log('import template to members error', error);
        throw error;
      })
    );
  }
}
